import { SITE_VARIABLES } from '../../common/styles/variables';

export const removeHighlights = {
  webkitTapHighlightColor: SITE_VARIABLES.COLORS.TRANSPARENT,
  webkitTouchCallout: 'none',
  webkitUserSelect: 'none',
  tapHighlightColor: SITE_VARIABLES.COLORS.TRANSPARENT,
  touchCallout: 'none',
  userSelect: 'none',
};
